export function clone(value) {
	return JSON.parse(JSON.stringify(value));
}

export function clampNumber(value, min, max, fallback = min) {
	const numeric = Number(value);

	if (!Number.isFinite(numeric)) {
		return fallback;
	}

	return Math.min(max, Math.max(min, numeric));
}

export function roundNumber(value, precision = 2) {
	const factor = 10 ** precision;

	return Math.round((Number(value) + Number.EPSILON) * factor) / factor;
}

export function quantizeMeters(value, step = 0.01) {
	const numeric = Number(value);
	const unit = Number(step);

	if (!Number.isFinite(numeric) || !Number.isFinite(unit) || unit <= 0) {
		return 0;
	}

	return roundNumber(Math.round(numeric / unit) * unit, getStepPrecision(unit));
}

function getStepPrecision(step) {
	const text = String(step);
	const decimal = text.includes(".") ? text.split(".")[1].length : 0;

	return Math.min(6, Math.max(2, decimal));
}

export function createDownload(filename, content) {
	const blob = new Blob([content], { type: "application/json" });
	const url = URL.createObjectURL(blob);
	const link = document.createElement("a");

	link.href = url;
	link.download = filename;
	link.click();

	setTimeout(() => URL.revokeObjectURL(url), 0);
}

export function createBinaryDownload(filename, content, mimeType = "application/octet-stream") {
	const blob = new Blob([content], { type: mimeType });
	const url = URL.createObjectURL(blob);
	const link = document.createElement("a");

	link.href = url;
	link.download = filename;
	link.click();

	setTimeout(() => URL.revokeObjectURL(url), 0);
}

export function formatTimestamp(value) {
	if (!value) {
		return "Not saved yet";
	}

	const date = new Date(value);

	if (Number.isNaN(date.getTime())) {
		return String(value);
	}

	return date.toLocaleString();
}
